import { TextField } from '@mui/material';

const InventorySku = ({ sku, handleChangeSku, error }) => {
  return (
    <TextField
      sx={{ minHeight: '64px' }}
      label="SKU"
      name="sku"
      fullWidth
      variant="outlined"
      size="small"
      value={sku}
      onChange={handleChangeSku}
      error={!!error}
      helperText={error ? error : ''}
      InputLabelProps={{ shrink: true }}
    />
  );
};

export default InventorySku;
